export enum HeaderProperties {
  TRACEPARENT = 'traceparent',
  X_REQUEST_ID = 'x-request-id',
}
